import { render, staticRenderFns } from "./DynamicPriceSuggestion.vue?vue&type=template&id=f2b3c680&scoped=true&"
import script from "./DynamicPriceSuggestion.vue?vue&type=script&lang=js&"
export * from "./DynamicPriceSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b3c680",
  null
  
)

export default component.exports